import service from './RestService';
import { RestResponse } from '../types/response/RestResponse';
import { ExternalUser, ExternalUserProfileDetails, InternalUser, InternalUserFilter } from '../state/users/types';
import { UserRoleType } from '../state/user/types';

const path = '/users';

class UsersService {
  getInternalUsers = (filter: InternalUserFilter): RestResponse<InternalUser[]> => service.get(`${path}/internal/${filter}`);

  getExternalUsers = (): RestResponse<ExternalUser[]> => service.get(`${path}/external`);

  updateInternalUserRole = (userID: number, role: UserRoleType): RestResponse<InternalUser[]> =>
    service.post(`${path}/assign-role`, { userID, role });

  getExternalUserProfileDetails = (userID: number): RestResponse<ExternalUserProfileDetails> => service.get(`${path}/external/${userID}`);

  updateExternalUserProfileDetails = (userID: number, data: ExternalUserProfileDetails): RestResponse<ExternalUserProfileDetails> =>
    service.put(`${path}/external/${userID}`, data);
}

export default new UsersService();
